import EncryptedStorage from 'react-native-encrypted-storage';
import { Platform } from 'react-native';

/**
 * Переключатель звуков приложения (SND-3, «режим без звука»).
 *
 * <p>Хранится по образцу тактильной отдачи и визуальной темы: localStorage в вебе,
 * защищённое хранилище на устройстве. Один ключ на всё приложение — сообщения, входящий,
 * исходящий гудок и служебные тоны звонка; дробить настройку по ролям смысла нет, человек,
 * который выключает звук, выключает его целиком.
 *
 * <p><b>Это не замена беззвучному режиму телефона.</b> Системный режим уважается отдельно и
 * бесплатно — через категорию аудиосессии в самих проигрывателях (`Ambient` / `Ring`).
 * Этот переключатель нужен для другого случая: телефон со звуком, а конкретно от мессенджера
 * звука не хочется.
 */

const KEY = 'svyaz_sounds_enabled';

/** Умолчание — включено: мессенджер, молчащий из коробки, читается как сломанный. */
export const SOUNDS_ENABLED_BY_DEFAULT = true;

function isWeb(): boolean {
  return Platform.OS === 'web';
}

export async function readSoundsEnabled(): Promise<boolean> {
  let raw: string | null;
  if (isWeb()) {
    try {
      raw =
        typeof globalThis.localStorage === 'undefined'
          ? null
          : globalThis.localStorage.getItem(KEY);
    } catch {
      raw = null;
    }
  } else {
    try {
      raw = await EncryptedStorage.getItem(KEY);
    } catch {
      raw = null;
    }
  }
  // Ничего не записано — умолчание. Выключает только явное «0»: мусор от прошлых версий
  // безопаснее прочитать как «включено», чем молча лишить человека звука, который он не
  // выключал.
  return raw === null ? SOUNDS_ENABLED_BY_DEFAULT : raw !== '0';
}

export async function writeSoundsEnabled(enabled: boolean): Promise<void> {
  const value = enabled ? '1' : '0';
  if (isWeb()) {
    try {
      globalThis.localStorage?.setItem(KEY, value);
    } catch {
      /* noop */
    }
    return;
  }
  try {
    await EncryptedStorage.setItem(KEY, value);
  } catch {
    /* noop */
  }
}
